import React, { useEffect, useState } from 'react';
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import "./index.less";
import { isOwnProperty } from '@/utils/common';



interface menuConfig extends MenuProps {
  updateIndex:number;
}



const MenusAntd = (props:{menuConfig:menuConfig}) => {
  const {menuConfig}=props;
  console.log('MenusAntd',menuConfig);
  const config:any={
    ...menuConfig,
  }
  if(isOwnProperty(config,'updateIndex')){
    delete config.updateIndex;
  }
  if(isOwnProperty(config,'meta')){
    delete config.meta;
  }
  useEffect(()=>{
    return ()=>{
      console.log('MenusAntd unmount');
    }
  },[]);
  return (
    <div className='menus-antd-container'>
      <Menu
        className='menus-antd'
        {...config}
      />
    </div>
    
  );
};

export default React.memo(MenusAntd,(prevProps, nextProps) => {
  return prevProps.menuConfig.updateIndex===nextProps.menuConfig.updateIndex;
});